(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("base"), require("core"), require("ui"));
	else if(typeof define === 'function' && define.amd)
		define("widget-hdfc-hongkong-search-integration", ["base", "core", "ui"], factory);
	else if(typeof exports === 'object')
		exports["widget-hdfc-hongkong-search-integration"] = factory(require("base"), require("core"), require("ui"));
	else
		root["widget-hdfc-hongkong-search-integration"] = factory(root["base"], root["core"], root["ui"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition